import { useParams } from "react-router-dom";
import EditMassMailing from "./massmailing/EditMassMailing";
import { LoadingOverlay, Paper } from "@mantine/core";
import EmailSmtp from "./smtp/EmailSmtp";
import { useCallback, useEffect, useState } from "react";
import { findEmail } from "../../../../api/EmailAPI";

const EmailEditPage = ({ handleClose, onEdited }) => {
  const { accountId } = useParams();
  const [emailProfile, setEmailProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (accountId) {
      setLoading(true);
      findEmail(accountId)
        .then((response) =>
          setEmailProfile(response.data.email_account_profile)
        )
        .finally(() => setLoading(false));
    }
  }, [accountId]);

  const getComponent = useCallback(() => {
    if (emailProfile?.account_type === "MassMailing") {
      return (
        <EditMassMailing
          emailProfile={emailProfile}
          handleClose={handleClose}
          onEdited={onEdited}
        />
      );
    } else {
      return (
        <EmailSmtp
          emailProfile={emailProfile}
          handleClose={handleClose}
          onEdited={onEdited}
        />
      );
    }
  }, [emailProfile]);

  return (
    <Paper
      p={"lg"}
      gap={"xs"}
      pos={"relative"}
      h={"100%"}
      mb={16}
      style={{ boxShadow: "#00000012 0 2px 6px", overflow: "hidden" }}
    >
      {loading ? <LoadingOverlay visible /> : getComponent()}
    </Paper>
  );
};

export default EmailEditPage;
